import {Link} from "react-router-dom";
import {PATHS, PATHS_API} from "../../../../../../../../enum";
import {useUserStore} from "../../../../../../../../modules/shop/user/store";
import {useI18n} from "../../../../../../../i18n/I18nProvider";

const ContentShop = ({setActive}) => {
    const { t } = useI18n();
    const user = useUserStore(store => store.user)

    return (
        <div className="content-shop">
            <Link
                className="burger-content-btn"
                to="/stats"
                onClick={() => setActive(false)}
            >
                {t("nav.stats")}
            </Link>
            { user?.steamId ?
                <>
                    <Link
                        className="burger-content-btn"
                        to={PATHS.PROFILE + "/basket"}
                        onClick={() => setActive(false)}
                    >
                        {t("nav.profile")}
                    </Link>
                    <a style={{"textDecoration" : "none", margin: "20px 0"}} className='btn' href={PATHS_API.LOGOUT}>
                        {t("nav.logout")}
                    </a>
                </>
                :
                <a style={{"textDecoration" : "none", margin: "20px 0"}} className='btn' href={PATHS_API.LOGIN}>
                    {t("nav.login")}
                </a>
            }

            {/*<ThemeSwitcher />*/}
        </div>
    );
};

export default ContentShop;